/* Camera Hub — interactive layer v5.2
   Quick typewriter on the three brand sentences with a moving
   insertion caret. Disabled for prefers-reduced-motion. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* quick, still human-feeling pacing */
  var BASE_MS = 24; /* average per character */
  var JITTER_MS = 18; /* random variance */
  var PAUSE_COMMA_MS = 100;
  var PAUSE_END_MS = 160; /* after . ! ? — */
  var PAUSE_WORD_MS = 10; /* extra after a space */

  var UNDERLINE_SENTENCES = [
    'founded by passionate photographers, we curate trusted, pre-owned cameras',
    'rediscover the art of capture',
    'every camera is hand-selected, meticulously inspected'
  ];

  function normalize(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function mediaBoxFor(card) {
    return (
      card.querySelector('.card-gallery, .product-card__media, [class*="media"], figure') ||
      card
    );
  }

  function textNodesIn(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.length) nodes.push(n);
    }
    return nodes;
  }

  function delayFor(ch) {
    var d = BASE_MS + Math.random() * JITTER_MS;
    if (ch === ',' || ch === ';' || ch === ':') d += PAUSE_COMMA_MS;
    else if (ch === '.' || ch === '!' || ch === '?' || ch === '—' || ch === '–') d += PAUSE_END_MS;
    else if (ch === ' ') d += PAUSE_WORD_MS;
    return d;
  }

  /* typewriter with a moving insertion caret */
  function typeOut(el) {
    if (el.dataset.chTyped) return;
    el.dataset.chTyped = '1';

    var nodes = textNodesIn(el);
    if (!nodes.length) return;

    /* reserve space to avoid layout jumps */
    el.style.minHeight = el.offsetHeight + 'px';

    var originals = nodes.map(function (n) { return n.nodeValue; });
    nodes.forEach(function (n) { n.nodeValue = ''; });

    /* insertion caret element — travels with the typed text */
    var caret = document.createElement('span');
    caret.className = 'ch-caret';
    caret.setAttribute('aria-hidden', 'true');

    function placeCaretAfter(node) {
      if (node.nextSibling) {
        node.parentNode.insertBefore(caret, node.nextSibling);
      } else {
        node.parentNode.appendChild(caret);
      }
    }

    placeCaretAfter(nodes[0]);

    var ni = 0;
    var ci = 0;

    function tick() {
      if (ni >= nodes.length) {
        /* let the caret blink briefly at the end, then remove it */
        setTimeout(function () {
          if (caret.parentNode) caret.parentNode.removeChild(caret);
          el.style.minHeight = '';
        }, 1200);
        return;
      }

      var target = originals[ni];
      var ch = target.charAt(ci);
      ci++;
      nodes[ni].nodeValue = target.slice(0, ci);
      placeCaretAfter(nodes[ni]);

      if (ci >= target.length) {
        ni++;
        ci = 0;
      }

      setTimeout(tick, delayFor(ch));
    }

    tick();
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* --- find + tag the brand sentences --- */
    var underlined = [];
    var textEls = main.querySelectorAll('h1, h2, h3, h4, h5, h6, p, li, blockquote, span');
    Array.prototype.forEach.call(textEls, function (el) {
      var t = normalize(el.textContent);
      if (!t) return;
      UNDERLINE_SENTENCES.forEach(function (sentence) {
        if (t.indexOf(sentence) !== -1) {
          var hasChildMatch = Array.prototype.some.call(
            el.querySelectorAll('*'),
            function (child) {
              return normalize(child.textContent).indexOf(sentence) !== -1;
            }
          );
          if (!hasChildMatch && underlined.indexOf(el) === -1) {
            el.classList.add('ch-underline');
            underlined.push(el);
          }
        }
      });
    });

    if (reduced) return;

    var toObserve = [];

    /* --- typewriter when the sentences come into view --- */
    if ('IntersectionObserver' in window && underlined.length) {
      var typeIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            typeOut(entry.target);
            typeIo.unobserve(entry.target);
          });
        },
        { threshold: 0.4 }
      );
      underlined.forEach(function (el) { typeIo.observe(el); });
    }

    /* --- product cards: zoom + animated outline --- */
    var cards = Array.prototype.slice.call(
      main.querySelectorAll('product-card, .product-card')
    );

    cards.forEach(function (card, i) {
      var box = mediaBoxFor(card);
      box.classList.add('ch-media');
      if (getComputedStyle(box).position === 'static') {
        box.style.position = 'relative';
      }

      if (!box.querySelector('.ch-orbit')) {
        var orbit = document.createElement('div');
        orbit.className = 'ch-orbit';
        orbit.setAttribute('aria-hidden', 'true');
        box.appendChild(orbit);
      }

      if (!card.querySelector('.ch-cta')) {
        var cta = document.createElement('div');
        cta.className = 'ch-cta';
        cta.setAttribute('aria-hidden', 'true');
        cta.innerHTML = 'View product<span class="ch-arrow">→</span>';
        card.appendChild(cta);
      }

      card.classList.add('ch-reveal');
      card.style.setProperty('--ch-delay', (i % 4) * 80 + 'ms');
      toObserve.push(card);
    });

    /* --- animated text entrances (typed sentences excluded) --- */
    var animEls = main.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, li, blockquote, figcaption'
    );
    Array.prototype.forEach.call(animEls, function (el, i) {
      if (el.closest('product-card, .product-card')) return;
      if (el.classList.contains('ch-underline') || el.querySelector('.ch-underline')) return;
      el.classList.add('ch-txt');
      el.style.setProperty('--ch-delay', (i % 6) * 60 + 'ms');
      toObserve.push(el);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('ch-in');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
      );
      toObserve.forEach(function (t) { io.observe(t); });
    } else {
      toObserve.forEach(function (t) { t.classList.add('ch-in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
